import classNames from 'classnames';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from '@wix/design-system';
import { usePageModeContext } from '../../../providers/PageMode/PageMode.provider';
import { ADVANCED_PLANS_APP_STEPS } from '../../../stores/App.store';
import { isDomainFunnelReferral } from 'utils';
import s from '../BackButton.scss';

export interface BackButtonProps {
  handleOnBackButtonClick(): void;
  currentStep: number;
  isSecondStepDisabled: boolean;
  className?: string;
}

const getStepTranslated = (t, currentStep, isSecondStepDisabled) => {
  return currentStep
    ? t(
        ADVANCED_PLANS_APP_STEPS[
          isSecondStepDisabled && currentStep === 2 ? 0 : currentStep - 1
        ],
      )
    : '';
};

export const BackButton: React.FunctionComponent<BackButtonProps> = ({
  handleOnBackButtonClick,
  currentStep,
  isSecondStepDisabled,
  className,
}) => {
  const { t } = useTranslation();
  const { theme } = usePageModeContext();
  const isHidden =
    currentStep <= 0 && !isDomainFunnelReferral();
  return (
    <div
      className={classNames(
        className,
        s.backButton,
        {
          [s.hidden]: isHidden,
        },
        theme,
      )}
    >
      <button
        data-hook='back-button'
        disabled={isHidden}
        onClick={handleOnBackButtonClick}
      >
        <div className={classNames(s.buttonIcon, theme)} />
        <div className={s.stepTitle}>
          <Text weight='bold' size='small'>
            {getStepTranslated(t, currentStep, isSecondStepDisabled)}
          </Text>
        </div>
      </button>
    </div>
  );
};
